module.exports = __webpack_public_path__ + "img/3.8f80c9b6.jpg";